/**
 * Client-side milestone service — fire-and-forget POST to /api/milestones.
 * All classification is server-side; frontend only reports identity + event.
 */

import { isValidCombination } from '../lib/analytics/milestones';

/**
 * Post a milestone event. Fire-and-forget — errors are logged, never thrown.
 *
 * @param feature  - Which feature area (from FEATURES catalog)
 * @param eventType - What type of event (from EVENT_TYPES catalog)
 * @param productId - Optional product ID for product-scoped milestones
 * @param metadata  - Optional metadata object (free-form JSON)
 */
export async function postMilestone(
  feature: string,
  eventType: string,
  productId?: number | string | null,
  metadata?: Record<string, unknown> | null,
): Promise<void> {
  // Client-side validation
  if (!isValidCombination(feature, eventType)) {
    console.warn(`[milestones] Invalid combination: ${feature}:${eventType}`);
    return;
  }

  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  if (!token) return; // not authenticated, skip silently

  const body: Record<string, unknown> = { feature, event_type: eventType };
  if (productId != null) body.product_id = productId;
  if (metadata != null) body.metadata = metadata;

  try {
    const res = await fetch('/api/milestones', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      console.warn(`[milestones] POST failed: ${res.status}`);
    }
  } catch (err) {
    // Fire-and-forget — never block the UI
    console.warn('[milestones] Network error:', err);
  }
}
